import { render, staticRenderFns } from "./ConfiguracaoLimiteCotasReserva.vue?vue&type=template&id=578b58e6&scoped=true&"
import script from "./ConfiguracaoLimiteCotasReserva.vue?vue&type=script&lang=js&"
export * from "./ConfiguracaoLimiteCotasReserva.vue?vue&type=script&lang=js&"
import style0 from "./ConfiguracaoLimiteCotasReserva.vue?vue&type=style&index=0&id=578b58e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "578b58e6",
  null
  
)

export default component.exports